import { useLang } from "@/contexts/LanguageContext";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

export default function FAQ() {
  const { t } = useLang();
  const items = t("faq.items");
  return (
    <section id="faq" data-testid="faq-section" className="bg-stone-100 py-24 md:py-40">
      <div className="max-w-5xl mx-auto px-6 md:px-10">
        <div className="text-center mb-16">
          <p className="text-eyebrow text-[#E07A5F] mb-4">{t("faq.eyebrow")}</p>
          <h2 className="font-serif-display text-4xl md:text-5xl lg:text-6xl leading-[1.05] tracking-tight text-stone-900">
            {t("faq.title")}
          </h2>
        </div>
        <Accordion type="single" collapsible className="space-y-3">
          {items.map((it, i) => (
            <AccordionItem
              key={i}
              value={`faq-${i}`}
              data-testid={`faq-item-${i}`}
              className="border border-stone-200 bg-white px-6 rounded-none"
            >
              <AccordionTrigger className="text-left font-serif-display text-xl md:text-2xl text-stone-900 hover:no-underline py-6">
                {it.q}
              </AccordionTrigger>
              <AccordionContent className="text-stone-700 text-base leading-relaxed pb-6">
                {it.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
